/**
 * @file 登录鉴权（localStorage）
 * @description 读写 `AUTH_TOKEN`；供登录页与路由守卫使用。
 *
 * @whenToUse 判断是否已登录、登录写入 token、退出清除 token。
 * @whenNotToUse 业务接口鉴权头封装（可在此基础上再包一层请求层）。
 */

/** localStorage 中的鉴权键名 */
export const AUTH_TOKEN_KEY = 'AUTH_TOKEN'

/** localStorage 中记住的登录账号键名 */
export const REMEMBERED_USERNAME_KEY = 'REMEMBERED_USERNAME'


/**
 * 读取当前 AUTH_TOKEN。
 * @returns token 字符串；未登录时为 null
 */
export function getAuthToken(): string | null {
  return localStorage.getItem(AUTH_TOKEN_KEY)
}

/**
 * 是否已登录（存在非空 AUTH_TOKEN）。
 */
export function isAuthenticated(): boolean {
  const token = getAuthToken()
  return Boolean(token)
}

/**
 * 登录成功：写入 AUTH_TOKEN。
 * @param token 登录接口返回的 access_token
 */
export function setAuthToken(token: string): void {
  localStorage.setItem(AUTH_TOKEN_KEY, token)
}

/**
 * 退出登录：清除 AUTH_TOKEN。
 */
export function clearAuthToken(): void {
  localStorage.removeItem(AUTH_TOKEN_KEY)
}

/**
 * 读取记住的登录账号。
 * @returns 账号字符串；未记住时为 null
 */
export function getRememberedUsername(): string | null {
  return localStorage.getItem(REMEMBERED_USERNAME_KEY)
}

/**
 * 记住登录账号。
 * @param username 账号
 */
export function setRememberedUsername(username: string): void {
  localStorage.setItem(REMEMBERED_USERNAME_KEY, username)
}

/**
 * 清除记住的登录账号。
 */
export function clearRememberedUsername(): void {
  localStorage.removeItem(REMEMBERED_USERNAME_KEY)
}
